import $ from "jquery";
import "magnific-popup";
import Swiper from "swiper/swiper-bundle";

function openModal() {
  $(".open-magnific-popup").magnificPopup({
    type: "inline",
    midClick: true, // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
  });
}

export { openModal };

function initV2Modal() {
  var mySwiper = undefined;

  function initModal() {
    function initSwiper(slideNumber) {
      $(".v2-tab-modal-slider").each(function () {
        mySwiper = new Swiper(this, {
          loop: false,
          autoplay: false,
          // autoHeight: true,
          effect: "fade",
          fadeEffect: {
            crossFade: true,
          },
          slidesPerView: 1,
          slidesPerGroup: 1,
          keyboard: {
            enabled: true,
          },
          navigation: {
            nextEl: ".v2-tab-modal-slider-next",
            prevEl: ".v2-tab-modal-slider-prev",
          },
          pagination: {
            el: ".swiper-pagination",
            type: "bullets",
          },
        });

        mySwiper.slideTo(slideNumber, 100, false);
      });
    }

    $(".js-open-tab-modal").magnificPopup({
      type: "inline",
      midClick: true,
      callbacks: {
        open: function () {
          const slideNumber = $(this.st.el).data("slide");

          initSwiper(slideNumber);

          mySwiper.update();
        },
        close: function () {
          $(".v2-tab-modal-slider").each(function () {
            mySwiper.destroy();
          });
        },
      },
    });
  }

  const isPresent = document.getElementsByClassName("v2-tab-modal-slider");

  if (isPresent.length > 0) {
    $(document).ready(() => {
      initModal();
    });
  }
}

export { initV2Modal };

function initV2ImgModal() {
  var mySwiper = undefined;

  function initModal() {
    function initSwiper(slideNumber) {
      $(".v2-tab-img-modal-slider").each(function () {
        mySwiper = new Swiper(this, {
          loop: false,
          autoplay: false,
          // autoHeight: true,
          effect: "fade",
          fadeEffect: {
            crossFade: true,
          },
          slidesPerView: 1,
          slidesPerGroup: 1,
          keyboard: {
            enabled: true,
          },
          navigation: {
            nextEl: ".v2-tab-img-modal-slider-next",
            prevEl: ".v2-tab-img-modal-slider-prev",
          },
          pagination: {
            el: ".swiper-pagination",
            type: "bullets",
          },
        });

        mySwiper.slideTo(slideNumber, 100, false);
      });
    }

    $(".js-open-tab-img-modal").magnificPopup({
      type: "inline",
      midClick: true,
      callbacks: {
        open: function () {
          if ($(this.st.el).data("slide") == null) {
            initSwiper();
          } else {
            const slideNumber = $(this.st.el).data("slide");
            initSwiper(slideNumber);
            mySwiper.update();
          }
        },
        close: function () {
          $(".v2-tab-img-modal-slider").each(function () {
            mySwiper.destroy();
          });
        },
      },
    });
  }

  const isPresent = document.getElementsByClassName("v2-tab-img-modal-slider");

  if (isPresent.length > 0) {
    $(document).ready(() => {
      initModal();
    });
  }
}

export { initV2ImgModal };

function initModalImgs() {
  var mySwiper = undefined;

  function initModal() {
    function initSwiper(slideNumber) {
      $(".v2-modal-imgs-slider").each(function () {
        mySwiper = new Swiper(this, {
          loop: true,
          autoplay: false,
          autoHeight: true,
          effect: "fade",
          initialSlide: slideNumber,
          fadeEffect: {
            crossFade: true,
          },
          slidesPerView: 1,
          slidesPerGroup: 1,
          keyboard: {
            enabled: true,
          },
          navigation: {
            nextEl: ".v2-modal-imgs-slider-next",
            prevEl: ".v2-modal-imgs-slider-prev",
          },
        });

        // mySwiper.slideTo(slideNumber, 100, false);
      });
    }

    $(".js-open-modal-imgs").magnificPopup({
      type: "inline",
      midClick: true,
      callbacks: {
        open: function () {
          // const slideNumber = $(this.st.el).data("swiper-slide-index");
          const slideNumber = $(this.st.el).parent().data("swiper-slide-index");

          initSwiper(slideNumber);

          mySwiper.update();
        },
        close: function () {
          $(".v2-modal-imgs-slider").each(function () {
            mySwiper.destroy();
          });
        },
      },
    });
  }

  const isPresent = document.getElementsByClassName("v2-modal-imgs-slider");

  if (isPresent.length > 0) {
    $(document).ready(() => {
      initModal();
    });
  }
}

export { initModalImgs };
